"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8931],{

/***/ 57706:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O6": function() { return /* binding */ StyledInputLabelBottom; },
/* harmony export */   "Yc": function() { return /* binding */ StyledFieldWrapper; }
/* harmony export */ });
/* unused harmony exports StyledFormInput, StyledButtonWrapper, StyledButton */
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(50029);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59499);
/* harmony import */ var _material_ui_core_Button__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(282);
/* harmony import */ var _material_ui_core_Box__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(50253);
/* harmony import */ var _material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(22318);
/* harmony import */ var _material_ui_core_Container__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(43832);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91315);
/* harmony import */ var common_utils_formatters__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(93058);
/* harmony import */ var components_GenericButton_GenericButton__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92208);
/* harmony import */ var components_GenericInput_GenericInput__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9108);
/* harmony import */ var components_PurchasePage_GroupPurchasesContext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(28218);
/* harmony import */ var components_Reusable_Bit_Form_FormikForm__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(34968);
/* harmony import */ var components_Reusable_Bit_FormikSchema__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(39163);
/* harmony import */ var components_Reusable_FormsComp_FormInput__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(37364);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(50066);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(74231);
/* harmony import */ var _GroupPurchasesHeader__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(86057);
/* harmony import */ var _GroupPurchasesPageCover__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(85991);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(85893);








function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

















var RECAPTCHA_KEY = "6LdBc5YiAAAAABjC-OWsg7BFb01Rd-j-nwJcXLx-";

if (!RECAPTCHA_KEY) {
  throw new Error("Please provide the RECAPTCHA_KEY environment variable.");
}

var StyledWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP)(_material_ui_core_Container__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z).withConfig({
  displayName: "GroupPurchasesAmountPage__StyledWrapper",
  componentId: "sc-1kgnwrc-0"
})(["margin-top:80px;padding-right:0px;padding-left:0px;", "{display:flex;flex-direction:row-reverse;margin-top:120px;justify-content:space-between;}"], function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledInputLabelBottom = (0,styled_components__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z).attrs({
  variant: "h3"
}).withConfig({
  displayName: "GroupPurchasesAmountPage__StyledInputLabelBottom",
  componentId: "sc-1kgnwrc-1"
})(["color:#000000;margin-top:12px;margin-bottom:110px;font-size:18px;font-weight:400;line-height:24px;text-align:right;font-family:\"NarkisBlock-Thin\";", "{margin-bottom:56px;}"], function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledFormInput = (0,styled_components__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP)(components_Reusable_FormsComp_FormInput__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z).withConfig({
  displayName: "GroupPurchasesAmountPage__StyledFormInput",
  componentId: "sc-1kgnwrc-2"
})([".MuiInputBase-multiline{height:80px;fieldset{height:80px;top:0px;}", "{height:120px;width:680px;fieldset{height:120px;top:0px;}}}.MuiOutlinedInput-adornedEnd{cursor:pointer;padding-left:unset;.MuiIconButton-root{padding:14px;&:hover{background-color:transparent;}}}.MuiOutlinedInput-root.Mui-error{background-color:#f7f7f7;}.MuiOutlinedInput-root:not(.Mui-error):hover .MuiOutlinedInput-notchedOutline{border-color:transparent;}.Mui-focused{background-color:white;}.MuiOutlinedInput-input{padding:14px 8px;color:#000000;font-size:20px;font-weight:400;line-height:22px;text-align:right;::placeholder{color:#00000066;font-size:20px;font-weight:400;line-height:22px;text-align:right;opacity:1;}:focus::placeholder{color:transparent;}}.MuiFormHelperText-root:not(.Mui-error){display:none;}"], function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledButtonWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z).withConfig({
  displayName: "GroupPurchasesAmountPage__StyledButtonWrapper",
  componentId: "sc-1kgnwrc-3"
})(["width:328px;margin-bottom:40px;margin-top:86px;position:relative;", "{margin-top:20px;position:fixed;bottom:0;right:0;width:calc(100% - 32px);border-radius:10px;box-shadow:0 -5px 10px 0 hsla(0,0%,0%,0.12);background-color:#fff;padding:12px 16px 10px 16px;margin-top:0px;z-index:999;margin-bottom:0px;}box-sizing:content-box;"], function (p) {
  return p.theme.breakpoints.down("sm");
});
var StyledButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP)(_material_ui_core_Button__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z).attrs({
  variant: "contained"
}).withConfig({
  displayName: "GroupPurchasesAmountPage__StyledButton",
  componentId: "sc-1kgnwrc-4"
})(["color:", ";background-color:", ";height:48px;width:100%;&:hover{background-color:", " !important;color:", ";}&:disabled{background-color:", " !important;color:#757575 !important;}", "{border-radius:0px;}"], function (p) {
  return p.$color;
}, function (p) {
  return p.$background;
}, function (p) {
  return p.$background;
}, function (p) {
  return p.$color;
}, function (p) {
  return p.theme.colors.disabled;
}, function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledMain = (0,styled_components__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z).withConfig({
  displayName: "GroupPurchasesAmountPage__StyledMain",
  componentId: "sc-1kgnwrc-5"
})(["padding-left:16px;padding-right:16px;", "{padding-left:60px;padding-right:60px;}"], function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledFieldWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z).withConfig({
  displayName: "GroupPurchasesAmountPage__StyledFieldWrapper",
  componentId: "sc-1kgnwrc-6"
})(["display:flex;", "{> *{width:100%;}}.MuiFormLabel-asterisk{display:none;}"], function (p) {
  return p.theme.breakpoints.down("sm");
});

var GroupPurchasesAmountPage = function GroupPurchasesAmountPage() {
  var amountInputRef = (0,react__WEBPACK_IMPORTED_MODULE_9__.useRef)(null);

  var _useGroupPurchasesCon = (0,components_PurchasePage_GroupPurchasesContext__WEBPACK_IMPORTED_MODULE_5__/* .useGroupPurchasesContext */ .ZA)(),
      groupPurchasesData = _useGroupPurchasesCon.groupPurchasesData,
      setGroupPurchasesData = _useGroupPurchasesCon.setGroupPurchasesData,
      setGroupPurchasesSteps = _useGroupPurchasesCon.setGroupPurchasesSteps,
      setPrevPageId = _useGroupPurchasesCon.setPrevPageId,
      setPrevPath = _useGroupPurchasesCon.setPrevPath; // Enables hitting back button while navigating through SPA style page


  setPrevPageId(1);
  setPrevPath("/groupPurchases");
  var groupPurchasesInitialData = {
    price: (groupPurchasesData === null || groupPurchasesData === void 0 ? void 0 : groupPurchasesData.price) || ""
  };
  var formikRef = (0,react__WEBPACK_IMPORTED_MODULE_9__.useRef)(null);

  var saveGroupPurchasesData = function saveGroupPurchasesData() {
    if (formikRef.current) {
      var _formikRef$current;

      var formValues = (_formikRef$current = formikRef.current) === null || _formikRef$current === void 0 ? void 0 : _formikRef$current.values;
      setGroupPurchasesData(_objectSpread(_objectSpread({}, groupPurchasesData), formValues));
    }
  };

  var priceRef = (0,react__WEBPACK_IMPORTED_MODULE_9__.useRef)(null);

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_9__.useState)(0),
      maxAmount = _useState[0],
      setMaxAmount = _useState[1];

  (0,react__WEBPACK_IMPORTED_MODULE_9__.useEffect)(function () {
    var fetchData = /*#__PURE__*/function () {
      var _ref = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)( /*#__PURE__*/_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var _response$data, _response$data$body, response;

        return _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return (0,api__WEBPACK_IMPORTED_MODULE_2__.getGroupPurchaseGetGroupPurchaseSettings)();

              case 3:
                response = _context.sent;
                setMaxAmount(response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$body = _response$data.body) === null || _response$data$body === void 0 ? void 0 : _response$data$body.maxPrice);

                if (response && groupPurchasesData.price) {
                  if (priceRef.current) {
                    setTimeout(function () {
                      priceRef.current.getElementsByTagName("input")[0].focus();
                      setTimeout(function () {
                        priceRef.current.getElementsByTagName("input")[0].blur();
                      }, 50);
                    }, 50);
                  }
                }

                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](0);
                console.error(_context.t0);

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 8]]);
      }));

      return function fetchData() {
        return _ref.apply(this, arguments);
      };
    }();

    fetchData(); // Scroll to top on page load

    if (window) {
      window.scrollTo(0, 0);
    }
  }, []);
  var schemaGroupPurchasesAmount = yup__WEBPACK_IMPORTED_MODULE_10__/* .object */ .Ry({
    price: yup__WEBPACK_IMPORTED_MODULE_10__/* .string */ .Z_().matches(components_Reusable_Bit_FormikSchema__WEBPACK_IMPORTED_MODULE_7__/* .regex.amount */ .Sz.amount, components_Reusable_Bit_FormikSchema__WEBPACK_IMPORTED_MODULE_7__/* .invalid.amount */ .I1.amount).test("min-value", "צריך להיות לפחות 10 ₪", function (value) {
      var numericValue = parseFloat(value === null || value === void 0 ? void 0 : value.replace(/[^\d.-]/g, ""));
      return numericValue > 9;
    }).test("max-value", components_Reusable_Bit_FormikSchema__WEBPACK_IMPORTED_MODULE_7__/* .invalid.groupPurchaseAmount */ .I1.groupPurchaseAmount, function (value) {
      var numericValue = parseFloat(value === null || value === void 0 ? void 0 : value.replace(/[^\d.-]/g, ""));
      return numericValue <= maxAmount;
    }).required(components_Reusable_Bit_FormikSchema__WEBPACK_IMPORTED_MODULE_7__/* .required["default"] */ .C1["default"])
  }).defined();
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsxs)(StyledWrapper, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(_GroupPurchasesPageCover__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
      backBtnOnClick: saveGroupPurchasesData
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsxs)(StyledMain, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(_GroupPurchasesHeader__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
        mainTitle: "כמה כסף לאסוף מכל אחד?",
        subTitle: "כל חבר/חברה שיקבלו הזמנה לקבוצה יראו את הסכום שקבעת, אבל עדיין יוכלו לבחור סכום אחר",
        component: "h2",
        backBtnOnClick: saveGroupPurchasesData
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(components_Reusable_Bit_Form_FormikForm__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        innerRef: formikRef,
        validationSchema: schemaGroupPurchasesAmount,
        initialValues: groupPurchasesInitialData,
        onSubmit: /*#__PURE__*/function () {
          var _ref2 = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)( /*#__PURE__*/_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2(values) {
            var _values$price$split;

            return _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    setGroupPurchasesData(_objectSpread(_objectSpread({}, groupPurchasesData), {}, {
                      price: typeof values.price === "string" ? parseInt((_values$price$split = values.price.split("₪")) === null || _values$price$split === void 0 ? void 0 : _values$price$split[1]) : values.price
                    }));
                    setGroupPurchasesSteps(components_PurchasePage_GroupPurchasesContext__WEBPACK_IMPORTED_MODULE_5__/* .GroupPurchasesSteps.LeaderDetails */ .NT.LeaderDetails);

                  case 2:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2);
          }));

          return function (_x) {
            return _ref2.apply(this, arguments);
          };
        }(),
        render: function render(formik) {
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.Fragment, {
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(StyledFieldWrapper, {
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(components_GenericInput_GenericInput__WEBPACK_IMPORTED_MODULE_4__/* .GenericInput */ .j, {
                innerRef: priceRef,
                name: "price",
                label: "\u05D4\u05D6\u05E0\u05EA \u05E1\u05DB\u05D5\u05DD (*\u05D7\u05D5\u05D1\u05D4)",
                $width: "328",
                $mobileWidth: "100%",
                type: "text",
                maxLength: 30,
                topMargin: "0",
                placeholder: "\u05E1\u05DB\u05D5\u05DD \u05DC\u05D0\u05E1\u05D5\u05E3 \u05DE\u05DB\u05DC \u05DE\u05E9\u05EA\u05EA\u05E3/\u05EA",
                inputRef: amountInputRef,
                autoComplete: "off",
                numeric: true,
                required: true,
                "aria-required": true,
                value: (0,common_utils_formatters__WEBPACK_IMPORTED_MODULE_20__/* .formatCurrencyWithSybmol */ .Tp)(formik.values.price)
              })
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsxs)(StyledInputLabelBottom, {
              children: ["\u05E0\u05D9\u05EA\u05DF \u05DC\u05E8\u05DB\u05D5\u05E9 \u05E2\u05D3 \u05DC\u05E1\u05DB\u05D5\u05DD \u05E9\u05DC ", maxAmount, " \u05E9\u201D\u05D7"]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(StyledButtonWrapper, {
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(components_GenericButton_GenericButton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                type: "submit",
                btnType: "filled",
                isdisabled: (formik === null || formik === void 0 ? void 0 : formik.isSubmitting) || Object.keys(formik === null || formik === void 0 ? void 0 : formik.errors).length > 0,
                children: "\u05D4\u05DE\u05E9\u05DA"
              })
            })]
          });
        }
      })]
    })]
  });
};

/* harmony default export */ __webpack_exports__["ZP"] = (GroupPurchasesAmountPage);

/***/ }),

/***/ 7068:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var components_Reusable_Bit_FormikSchema__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39163);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74231);


var groupPurchasesInitialValues = {
  groupName: "",
  amount: undefined
};
var schemaGroupPurchasesGroupName = yup__WEBPACK_IMPORTED_MODULE_1__/* .object */ .Ry({
  name: components_Reusable_Bit_FormikSchema__WEBPACK_IMPORTED_MODULE_0__/* .schemaCommon.groupName */ .Cr.groupName
}).defined();
var schemaGroupPurchasesLeaderDetails = yup__WEBPACK_IMPORTED_MODULE_1__/* .object */ .Ry({
  firstName: components_Reusable_Bit_FormikSchema__WEBPACK_IMPORTED_MODULE_0__/* .schemaCommon.firstName */ .Cr.firstName,
  lastName: components_Reusable_Bit_FormikSchema__WEBPACK_IMPORTED_MODULE_0__/* .schemaCommon.lastName */ .Cr.lastName,
  phoneNumber: components_Reusable_Bit_FormikSchema__WEBPACK_IMPORTED_MODULE_0__/* .schemaCommon.phoneNumber */ .Cr.phoneNumber,
  email: components_Reusable_Bit_FormikSchema__WEBPACK_IMPORTED_MODULE_0__/* .schemaCommon.email */ .Cr.email,
  checkedOne: components_Reusable_Bit_FormikSchema__WEBPACK_IMPORTED_MODULE_0__/* .schemaCommon.checkbox */ .Cr.checkbox
}).defined();
var schemaGroupPurchasesRecipient = yup__WEBPACK_IMPORTED_MODULE_1__/* .object */ .Ry({
  name: components_Reusable_Bit_FormikSchema__WEBPACK_IMPORTED_MODULE_0__/* .schemaCommon.firstName */ .Cr.firstName,
  phoneNumber: components_Reusable_Bit_FormikSchema__WEBPACK_IMPORTED_MODULE_0__/* .schemaCommon.phoneNumber */ .Cr.phoneNumber,
  senderBlessing: components_Reusable_Bit_FormikSchema__WEBPACK_IMPORTED_MODULE_0__/* .schemaCommon.senderBlessing */ .Cr.senderBlessing // email: schemaCommon.email,

}).defined();
/* harmony default export */ __webpack_exports__["Z"] = ({
  groupPurchasesInitialValues: groupPurchasesInitialValues,
  schemaGroupPurchasesGroupName: schemaGroupPurchasesGroupName,
  schemaGroupPurchasesLeaderDetails: schemaGroupPurchasesLeaderDetails,
  schemaGroupPurchasesRecipient: schemaGroupPurchasesRecipient
});

/***/ }),

/***/ 86057:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(22318);
/* harmony import */ var _material_ui_core_Container__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(43832);
/* harmony import */ var common_MediaQueries__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1438);
/* harmony import */ var components_BackButton_BackButton__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36166);
/* harmony import */ var components_PurchasePage_GroupPurchasesContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28218);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50066);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);





 // Styled Components




var StyledContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_material_ui_core_Container__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).withConfig({
  displayName: "GroupPurchasesHeader__StyledContainer",
  componentId: "sc-16bcdwr-0"
})(["padding:0px;align-items:center;"]);
var StyledBackButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(components_BackButton_BackButton__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
  displayName: "GroupPurchasesHeader__StyledBackButton",
  componentId: "sc-16bcdwr-1"
})(["", "{margin-bottom:48px;}"], function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledTitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).withConfig({
  displayName: "GroupPurchasesHeader__StyledTitle",
  componentId: "sc-16bcdwr-2"
})(["text-align:right;margin-top:20px;font-size:40px;line-height:46px;font-family:Speedee,NarkisBlock,sans-serif;", "{margin-top:0px;}"], function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledSubtitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).withConfig({
  displayName: "GroupPurchasesHeader__StyledSubtitle",
  componentId: "sc-16bcdwr-3"
})(["text-align:right;word-break:break-word;margin:0;margin-top:20px;margin-bottom:30px;font-weight:400;color:#000000;font-size:20px;font-family:Speedee,NarkisBlockCondensed,sans-serif;", "{margin-top:30px;margin-bottom:30px;}"], function (p) {
  return p.theme.breakpoints.up("md");
});

var GroupPurchasesHeader = function GroupPurchasesHeader(_ref) {
  var mainTitle = _ref.mainTitle,
      subTitle = _ref.subTitle,
      backBtnOnClick = _ref.backBtnOnClick,
      alwaysShow = _ref.alwaysShow,
      component = _ref.component,
      subtitleComponent = _ref.subtitleComponent;
  var isDesktop = (0,common_MediaQueries__WEBPACK_IMPORTED_MODULE_0__/* .useIsDesktop */ .Ce)();

  var _useGroupPurchasesCon = (0,components_PurchasePage_GroupPurchasesContext__WEBPACK_IMPORTED_MODULE_2__/* .useGroupPurchasesContext */ .ZA)(),
      prevPath = _useGroupPurchasesCon.prevPath;

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
    children: [(alwaysShow || isDesktop) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(StyledContainer, {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(StyledBackButton, {
        linkText: "\u05D7\u05D6\u05E8\u05D4",
        prevPath: prevPath,
        hideTextOnMobile: true,
        beforeNavigation: function beforeNavigation() {
          backBtnOnClick && backBtnOnClick();
        }
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(StyledTitle, {
      variant: component || "h1",
      children: mainTitle
    }), subTitle && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(StyledSubtitle, {
      variant: subtitleComponent || "h2",
      children: subTitle
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (GroupPurchasesHeader);

/***/ }),

/***/ 85991:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(50029);
/* harmony import */ var _material_ui_core_Box__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(50253);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91315);
/* harmony import */ var common_MediaQueries__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1438);
/* harmony import */ var components_BackButton_BackButton__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36166);
/* harmony import */ var components_PurchasePage_GroupPurchasesContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28218);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(50066);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85893);












var StyledImageWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z).withConfig({
  displayName: "GroupPurchasesPageCover__StyledImageWrapper",
  componentId: "sc-1xp6pgc-0"
})(["position:relative;top:0;", "{", " top:0px;}"], function (p) {
  return p.theme.breakpoints.down("sm");
}, function (p) {
  return (p === null || p === void 0 ? void 0 : p.$hasImg) && "height: 250px;";
});
var StyledBackButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(components_BackButton_BackButton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
  displayName: "GroupPurchasesPageCover__StyledBackButton",
  componentId: "sc-1xp6pgc-1"
})(["padding:14px 16px 16px 16px;position:relative;z-index:999;", "{margin-bottom:48px;}"], function (p) {
  return p.theme.breakpoints.up("md");
});

var GroupPurchasesPageCover = function GroupPurchasesPageCover(_ref) {
  var backBtnOnClick = _ref.backBtnOnClick;
  var isDesktop = (0,common_MediaQueries__WEBPACK_IMPORTED_MODULE_2__/* .useIsDesktop */ .Ce)();

  var _useGroupPurchasesCon = (0,components_PurchasePage_GroupPurchasesContext__WEBPACK_IMPORTED_MODULE_4__/* .useGroupPurchasesContext */ .ZA)(),
      prevPath = _useGroupPurchasesCon.prevPath;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)({
    imageUrl: "",
    alt: ""
  }),
      coverImg = _useState[0],
      setCoverImg = _useState[1];

  (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function () {
    var fetchData = /*#__PURE__*/function () {
      var _ref2 = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)( /*#__PURE__*/_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var _response$data, _response$data$body, response;

        return _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return (0,api__WEBPACK_IMPORTED_MODULE_1__.getGroupPurchaseGetGroupPurchaseSettings)();

              case 3:
                response = _context.sent;
                setCoverImg(response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$body = _response$data.body) === null || _response$data$body === void 0 ? void 0 : _response$data$body.image);
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);
                console.error(_context.t0);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 7]]);
      }));

      return function fetchData() {
        return _ref2.apply(this, arguments);
      };
    }();

    fetchData();
  }, []);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(StyledImageWrapper, {
    $hasImg: !!(coverImg !== null && coverImg !== void 0 && coverImg.imageUrl),
    children: [!isDesktop && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(StyledBackButton, {
      linkText: "\u05D7\u05D6\u05E8\u05D4",
      prevPath: prevPath,
      hideTextOnMobile: true,
      beforeNavigation: function beforeNavigation() {
        backBtnOnClick && backBtnOnClick();
      }
    }), coverImg.imageUrl && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_5___default()), {
      src: coverImg.imageUrl,
      alt: coverImg.alt,
      layout: !isDesktop ? "fill" : "fixed",
      width: isDesktop && "404x",
      height: isDesktop && "267px",
      style: {
        borderRadius: isDesktop ? "22px" : "0px"
      }
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (GroupPurchasesPageCover);

/***/ }),

/***/ 54819:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ StyledMain; }
/* harmony export */ });
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(50029);
/* harmony import */ var _material_ui_core_Button__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(282);
/* harmony import */ var _material_ui_core_Box__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(50253);
/* harmony import */ var _material_ui_core_Container__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(43832);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87794);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91315);
/* harmony import */ var common_MediaQueries__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1438);
/* harmony import */ var components_GenericButton_GenericButton__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92208);
/* harmony import */ var components_GenericInput_GenericInput__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9108);
/* harmony import */ var components_OtpStep_OtpContext__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78461);
/* harmony import */ var components_PurchasePage_GroupPurchasesContext__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(28218);
/* harmony import */ var components_PurchasePage_LegalCheckboxes__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(40839);
/* harmony import */ var components_PurchasePage_PurchaseContext__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(33574);
/* harmony import */ var components_Reusable_Bit_Form_FormikForm__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(34968);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(67294);
/* harmony import */ var react_google_recaptcha__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(34853);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(50066);
/* harmony import */ var _GroupPurchasesForm__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(7068);
/* harmony import */ var _GroupPurchasesHeader__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(86057);
/* harmony import */ var _GroupPurchasesPageCover__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(85991);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(85893);






function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





















var RECAPTCHA_KEY = "6LdBc5YiAAAAABjC-OWsg7BFb01Rd-j-nwJcXLx-";

if (!RECAPTCHA_KEY) {
  throw new Error("Please provide the RECAPTCHA_KEY environment variable.");
}

var StyledWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .ZP)(_material_ui_core_Container__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z).withConfig({
  displayName: "LeaderDetailsPage__StyledWrapper",
  componentId: "sc-1kpsrku-0"
})(["margin-top:80px;padding-right:0px;padding-left:0px;", "{display:flex;flex-direction:row-reverse;margin-top:120px;justify-content:space-between;}"], function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledButtonWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .ZP)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z).withConfig({
  displayName: "LeaderDetailsPage__StyledButtonWrapper",
  componentId: "sc-1kpsrku-1"
})(["width:328px;margin-bottom:40px;margin-top:86px;position:relative;", "{margin-top:20px;position:fixed;bottom:0;right:0;width:calc(100% - 32px);border-radius:10px;box-shadow:0 -5px 10px 0 hsla(0,0%,0%,0.12);background-color:#fff;padding:12px 16px 10px 16px;margin-top:0px;z-index:999;margin-bottom:0px;}box-sizing:content-box;"], function (p) {
  return p.theme.breakpoints.down("sm");
});
var StyledButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .ZP)(_material_ui_core_Button__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z).attrs({
  variant: "contained"
}).withConfig({
  displayName: "LeaderDetailsPage__StyledButton",
  componentId: "sc-1kpsrku-2"
})(["color:", ";background-color:", ";height:48px;width:100%;&:hover{background-color:", " !important;color:", ";}&:disabled{background-color:", " !important;color:#757575 !important;}", "{border-radius:0px;}"], function (p) {
  return p.$color;
}, function (p) {
  return p.$background;
}, function (p) {
  return p.$background;
}, function (p) {
  return p.$color;
}, function (p) {
  return p.theme.colors.disabled;
}, function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledMain = (0,styled_components__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .ZP)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z).withConfig({
  displayName: "LeaderDetailsPage__StyledMain",
  componentId: "sc-1kpsrku-3"
})(["padding-left:16px;padding-right:16px;", "{padding-left:60px;padding-right:60px;}"], function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledFormLegend = (0,styled_components__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .ZP)("legend").withConfig({
  displayName: "LeaderDetailsPage__StyledFormLegend",
  componentId: "sc-1kpsrku-4"
})(["width:fit-content;font-size:26px;font-weight:bold;line-height:32px;text-align:right;color:#000000;margin-top:30px;font-family:Speedee,NarkisBlock,sans-serif;"]);
var StyledFieldWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .ZP)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z).withConfig({
  displayName: "LeaderDetailsPage__StyledFieldWrapper",
  componentId: "sc-1kpsrku-5"
})(["display:flex;flex-direction:row;flex-wrap:wrap;gap:27px;margin-top:47px;", "{gap:30px 10px;margin-top:27px;}", "{> *{width:100%;}}"], function (p) {
  return p.theme.breakpoints.up("md");
}, function (p) {
  return p.theme.breakpoints.down("sm");
});
var StyledLegalCheckboxesWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .ZP)("div").withConfig({
  displayName: "LeaderDetailsPage__StyledLegalCheckboxesWrapper",
  componentId: "sc-1kpsrku-6"
})(["margin-bottom:100px;", "{margin-bottom:0px;}"], function (p) {
  return p.theme.breakpoints.up("md");
});

var LeaderDetailsPage = function LeaderDetailsPage() {
  var _groupPurchasesData$e;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_12__.useState)(""),
      pageTitle = _useState[0],
      setPageTitle = _useState[1];

  var reCaptchaRef = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_12__.createRef)();
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_11__.useRouter)();

  var _useGroupPurchasesCon = (0,components_PurchasePage_GroupPurchasesContext__WEBPACK_IMPORTED_MODULE_7__/* .useGroupPurchasesContext */ .ZA)(),
      groupPurchasesData = _useGroupPurchasesCon.groupPurchasesData,
      setGroupPurchasesData = _useGroupPurchasesCon.setGroupPurchasesData,
      setGroupPurchasesSteps = _useGroupPurchasesCon.setGroupPurchasesSteps,
      setPrevPageId = _useGroupPurchasesCon.setPrevPageId,
      changed = _useGroupPurchasesCon.changed,
      setPrevPath = _useGroupPurchasesCon.setPrevPath;

  var _usePurchaseContext = (0,components_PurchasePage_PurchaseContext__WEBPACK_IMPORTED_MODULE_9__/* .usePurchaseContext */ .AX)(),
      setGroupPurchaseGuid = _usePurchaseContext.setGroupPurchaseGuid,
      groupPurchaseGuid = _usePurchaseContext.groupPurchaseGuid,
      setGroupPurchaseData = _usePurchaseContext.setGroupPurchaseData,
      groupPurchaseData = _usePurchaseContext.groupPurchaseData;

  var _useOtpContext = (0,components_OtpStep_OtpContext__WEBPACK_IMPORTED_MODULE_6__/* .useOtpContext */ .yQ)(),
      setTotalTimeoutInSeconds = _useOtpContext.setTotalTimeoutInSeconds,
      setPhoneNumber = _useOtpContext.setPhoneNumber;

  (0,react__WEBPACK_IMPORTED_MODULE_12__.useEffect)(function () {
    // Enables hitting back button while navigating through SPA style page
    setTimeout(function () {
      setPrevPageId(2);
      setPrevPath("/groupPurchases");
    }, 500);
  }, [changed]);

  var getCardData = /*#__PURE__*/function () {
    var _ref = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)( /*#__PURE__*/_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee(groupGuid) {
      var _getGroupPurchase$dat, getGroupPurchase;

      return _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return (0,api__WEBPACK_IMPORTED_MODULE_2__.postGroupPurchaseGetGroupPurchase)({
                groupPurchaseGuid: groupGuid
              });

            case 3:
              getGroupPurchase = _context.sent;
              getGroupPurchase && setGroupPurchaseData(getGroupPurchase === null || getGroupPurchase === void 0 ? void 0 : (_getGroupPurchase$dat = getGroupPurchase.data) === null || _getGroupPurchase$dat === void 0 ? void 0 : _getGroupPurchase$dat.body);
              _context.next = 10;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              console.log(_context.t0);

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 7]]);
    }));

    return function getCardData(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  (0,react__WEBPACK_IMPORTED_MODULE_12__.useEffect)(function () {
    var _router$query;

    if (router !== null && router !== void 0 && (_router$query = router.query) !== null && _router$query !== void 0 && _router$query.id) {
      var _router$query2, _router$query2$id;

      var groupGuid = router === null || router === void 0 ? void 0 : (_router$query2 = router.query) === null || _router$query2 === void 0 ? void 0 : (_router$query2$id = _router$query2.id) === null || _router$query2$id === void 0 ? void 0 : _router$query2$id.toString();
      setGroupPurchaseGuid(groupGuid);
      getCardData(groupGuid);
    }
  }, [router]);
  (0,react__WEBPACK_IMPORTED_MODULE_12__.useEffect)(function () {
    if (groupPurchaseGuid) {
      //@ts-ignore
      if (groupPurchaseData !== null && groupPurchaseData !== void 0 && groupPurchaseData.isDisabledGroup) {
        setPageTitle("הי, נראה שהקבוצה אינה פעילה יותר");
      } else {
        setPageTitle("\u05D4\u05D9\u05D9 \u05D4\u05D5\u05D6\u05DE\u05E0\u05EA \u05DC\u05D0\u05D9\u05E1\u05D5\u05E3 \u05DB\u05E1\u05E3 \u05E2\u05D1\u05D5\u05E8 \u05E8\u05DB\u05D9\u05E9\u05D4 \u05E7\u05D1\u05D5\u05E6\u05EA\u05D9\u05EA \u05DC\u05F4".concat( //@ts-ignore
        (groupPurchaseData === null || groupPurchaseData === void 0 ? void 0 : groupPurchaseData.groupName) || "", "\u05F4"));
      }
    } else {
      setPageTitle("זה הזמן למלא את הפרטים שלך כמנהל/ת הקבוצה");
    }
  }, [groupPurchaseGuid, groupPurchaseData]); // Scroll to top on page load

  (0,react__WEBPACK_IMPORTED_MODULE_12__.useEffect)(function () {
    if (window) {
      window.scrollTo(0, 0);
    }
  }, []);
  var groupPurchasesInitialData = {
    firstName: (groupPurchasesData === null || groupPurchasesData === void 0 ? void 0 : groupPurchasesData.firstName) || "",
    lastName: (groupPurchasesData === null || groupPurchasesData === void 0 ? void 0 : groupPurchasesData.lastName) || "",
    phoneNumber: (groupPurchasesData === null || groupPurchasesData === void 0 ? void 0 : groupPurchasesData.phoneNumber) || "",
    email: (groupPurchasesData === null || groupPurchasesData === void 0 ? void 0 : (_groupPurchasesData$e = groupPurchasesData.email) === null || _groupPurchasesData$e === void 0 ? void 0 : _groupPurchasesData$e.trim()) || "",
    //@ts-ignore
    checkedOne: (groupPurchasesData === null || groupPurchasesData === void 0 ? void 0 : groupPurchasesData.checkedOne) || false,
    checkedTwo: (groupPurchasesData === null || groupPurchasesData === void 0 ? void 0 : groupPurchasesData.approveMarketingContent) || false
  };
  var formikRef = (0,react__WEBPACK_IMPORTED_MODULE_12__.useRef)(null);

  var saveGroupPurchasesData = function saveGroupPurchasesData() {
    if (formikRef.current) {
      var _formikRef$current;

      var formValues = (_formikRef$current = formikRef.current) === null || _formikRef$current === void 0 ? void 0 : _formikRef$current.values;
      setGroupPurchasesData(_objectSpread(_objectSpread({}, groupPurchasesData), formValues));
    }
  };

  (0,react__WEBPACK_IMPORTED_MODULE_12__.useEffect)(function () {
    if (router.query && router.query.focus && document) {
      var _document;

      var input = (_document = document) === null || _document === void 0 ? void 0 : _document.getElementById(router.query.focus.toString());
      input === null || input === void 0 ? void 0 : input.scrollIntoView();
      setTimeout(function () {
        input === null || input === void 0 ? void 0 : input.focus();
      }, 1500);
    }
  }, [router]);

  var getVerificationCode = /*#__PURE__*/function () {
    var _ref2 = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)( /*#__PURE__*/_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee2(phone, gRecaptchaResponse) {
      var response;
      return _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              setGroupPurchasesSteps(components_PurchasePage_GroupPurchasesContext__WEBPACK_IMPORTED_MODULE_7__/* .GroupPurchasesSteps.LOADER */ .NT.LOADER);
              router.push("/groupPurchases/otp");
              _context2.next = 5;
              return (0,api__WEBPACK_IMPORTED_MODULE_2__.postGiftCardGenerateVerificationCode)({
                mobilePhone: phone.replace(/-/g, ""),
                toSendSms: true,
                gRecaptchaResponse: gRecaptchaResponse
              });

            case 5:
              response = _context2.sent;

              if ((response === null || response === void 0 ? void 0 : response.status) === 200 && response !== null && response !== void 0 && response.data) {
                setGroupPurchasesSteps(components_PurchasePage_GroupPurchasesContext__WEBPACK_IMPORTED_MODULE_7__/* .GroupPurchasesSteps.LeaderDetails */ .NT.LeaderDetails); // leaveBalancePage("phoneNumber")

                setTotalTimeoutInSeconds(response.data.body.totalTimeoutInSeconds);
              }

              _context2.next = 12;
              break;

            case 9:
              _context2.prev = 9;
              _context2.t0 = _context2["catch"](0);
              setGroupPurchasesSteps(components_PurchasePage_GroupPurchasesContext__WEBPACK_IMPORTED_MODULE_7__/* .GroupPurchasesSteps.FAIL */ .NT.FAIL);

            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 9]]);
    }));

    return function getVerificationCode(_x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsxs)(StyledWrapper, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(_GroupPurchasesPageCover__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
      backBtnOnClick: saveGroupPurchasesData
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsxs)(StyledMain, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(_GroupPurchasesHeader__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
        mainTitle: pageTitle,
        backBtnOnClick: saveGroupPurchasesData,
        component: "h2"
      }), //@ts-ignore
      groupPurchaseGuid && groupPurchaseData !== null && groupPurchaseData !== void 0 && groupPurchaseData.isDisabledGroup ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(StyledButtonWrapper, {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(StyledButton, {
          type: "button",
          $color: "#000",
          $background: "#ffb900",
          onClick: function onClick() {
            return router.push("/");
          },
          children: "\u05DC\u05E2\u05DE\u05D5\u05D3 \u05D4\u05D1\u05D9\u05EA"
        })
      }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(components_Reusable_Bit_Form_FormikForm__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
        innerRef: formikRef,
        validationSchema: _GroupPurchasesForm__WEBPACK_IMPORTED_MODULE_14__/* ["default"].schemaGroupPurchasesLeaderDetails */ .Z.schemaGroupPurchasesLeaderDetails,
        initialValues: groupPurchasesInitialData,
        onSubmit: /*#__PURE__*/function () {
          var _ref3 = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)( /*#__PURE__*/_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee3(values) {
            var _reCaptchaRef$current, _reCaptchaRef$current2, _values$email;

            var recaptchaResponse;
            return _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    reCaptchaRef === null || reCaptchaRef === void 0 ? void 0 : (_reCaptchaRef$current = reCaptchaRef.current) === null || _reCaptchaRef$current === void 0 ? void 0 : _reCaptchaRef$current.reset();
                    _context3.next = 3;
                    return reCaptchaRef === null || reCaptchaRef === void 0 ? void 0 : (_reCaptchaRef$current2 = reCaptchaRef.current) === null || _reCaptchaRef$current2 === void 0 ? void 0 : _reCaptchaRef$current2.executeAsync();

                  case 3:
                    recaptchaResponse = _context3.sent;
                    setGroupPurchasesData(_objectSpread(_objectSpread({}, groupPurchasesData), {}, {
                      firstName: values.firstName,
                      lastName: values.lastName,
                      email: (_values$email = values.email) === null || _values$email === void 0 ? void 0 : _values$email.trim(),
                      phoneNumber: values.phoneNumber,
                      approveMarketingContent: values.checkedTwo
                    }));
                    setPhoneNumber(values.phoneNumber.replace(/-/g, ""));
                    _context3.next = 8;
                    return getVerificationCode(values.phoneNumber, recaptchaResponse);

                  case 8:
                  case "end":
                    return _context3.stop();
                }
              }
            }, _callee3);
          }));

          return function (_x4) {
            return _ref3.apply(this, arguments);
          };
        }(),
        render: function render(formik) {
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.Fragment, {
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(common_MediaQueries__WEBPACK_IMPORTED_MODULE_3__/* .Desktop */ .Hi, {
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(StyledFormLegend, {
                children: "\u05D4\u05E4\u05E8\u05D8\u05D9\u05DD \u05E9\u05DC\u05D9"
              })
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsxs)(StyledFieldWrapper, {
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(components_GenericInput_GenericInput__WEBPACK_IMPORTED_MODULE_5__/* .GenericInput */ .j, {
                name: "firstName",
                label: "\u05E9\u05DD \u05E4\u05E8\u05D8\u05D9 (*\u05D7\u05D5\u05D1\u05D4)",
                type: "text",
                maxLength: 30,
                topMargin: "0",
                placeholder: "\u05E9\u05DD \u05E4\u05E8\u05D8\u05D9 (*\u05D7\u05D5\u05D1\u05D4)"
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(components_GenericInput_GenericInput__WEBPACK_IMPORTED_MODULE_5__/* .GenericInput */ .j, {
                name: "lastName",
                label: "\u05E9\u05DD \u05DE\u05E9\u05E4\u05D7\u05D4 (*\u05D7\u05D5\u05D1\u05D4)",
                type: "text",
                maxLength: 30,
                topMargin: "0",
                placeholder: "\u05E9\u05DD \u05DE\u05E9\u05E4\u05D7\u05D4 (*\u05D7\u05D5\u05D1\u05D4)"
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(components_GenericInput_GenericInput__WEBPACK_IMPORTED_MODULE_5__/* .GenericInput */ .j, {
                name: "phoneNumber",
                label: "(*\u05D7\u05D5\u05D1\u05D4) \u05DE\u05E1\u05E4\u05E8 \u05D8\u05DC\u05E4\u05D5\u05DF",
                type: "tel",
                maxLength: 30,
                topMargin: "0",
                placeholder: "\u05D8\u05DC\u05E4\u05D5\u05DF (*\u05D7\u05D5\u05D1\u05D4)"
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(components_GenericInput_GenericInput__WEBPACK_IMPORTED_MODULE_5__/* .GenericInput */ .j, {
                name: "email",
                label: "(*\u05D7\u05D5\u05D1\u05D4) \u05DE\u05D9\u05D9\u05DC",
                type: "email",
                maxLength: 60,
                topMargin: "0",
                placeholder: "\u05D0\u05D9\u05DE\u05D9\u05D9\u05DC (*\u05D7\u05D5\u05D1\u05D4)"
              })]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(StyledLegalCheckboxesWrapper, {
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(components_PurchasePage_LegalCheckboxes__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                saveGiftCardData: saveGroupPurchasesData,
                prevPageId: 3
              })
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(StyledButtonWrapper, {
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(components_GenericButton_GenericButton__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                type: "submit",
                btnType: "filled",
                isdisabled: (formik === null || formik === void 0 ? void 0 : formik.isSubmitting) || Object.keys(formik === null || formik === void 0 ? void 0 : formik.errors).length > 0,
                children: "\u05D4\u05DE\u05E9\u05DA"
              })
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(react_google_recaptcha__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
              ref: reCaptchaRef,
              sitekey: RECAPTCHA_KEY,
              size: "invisible",
              hl: "iw",
              tabIndex: -1
            })]
          });
        }
      })]
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (LeaderDetailsPage);

/***/ }),

/***/ 37364:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(16835);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(4730);
/* harmony import */ var _material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(22318);
/* harmony import */ var _material_ui_core_InputLabel__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85161);
/* harmony import */ var _material_ui_core_FormControl__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64436);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82175);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50066);
/* harmony import */ var _Bit_Form_FormikInput__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60137);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);






var _excluded = ["name", "label", "type", "required", "placeholder", "maxLength", "numeric", "InputProps", "centerField", "autoFocus", "topMargin", "mobileTopMargin"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// import ErrorIcon from "components/Icons/ErrorIcon"




var Styled = {
  Field: (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(formik__WEBPACK_IMPORTED_MODULE_1__.Field).withConfig({
    displayName: "FormInput__Field",
    componentId: "sc-kr1sqg-0"
  })(["width:100%;.MuiFormHelperText-root{font-size:20px;}.MuiFormHelperText-root.Mui-error{", ";}input{", "}"], function (p) {
    return p.$center ? "text-align: center;" : "";
  }, function (p) {
    return p.$center ? "text-align: center;" : "";
  }),
  FormControl: (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_material_ui_core_FormControl__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).withConfig({
    displayName: "FormInput__FormControl",
    componentId: "sc-kr1sqg-1"
  })(["display:flex;", "{width:100%;}"], function (p) {
    return p.theme.breakpoints.down("sm");
  }),
  FieldWrapper: styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "FormInput__FieldWrapper",
    componentId: "sc-kr1sqg-2"
  })(["margin-top:", ";input{font-family:Speedee,NarkisBlock,sans-serif;color:#000;font-size:20px;font-weight:500;}input[type=\"email\"]{font-size:16px;font-family:sans-serif,Speedee;font-weight:normal;}input::-webkit-outer-spin-button,input::-webkit-inner-spin-button{-webkit-appearance:none;}.MuiOutlinedInput-root.Mui-error{fieldset{box-shadow:none;border:1px solid rgba(215,2,2,0.5);top:0;}}.MuiOutlinedInput-root{box-shadow:none;border-radius:8px;border:1px #e5e5e5 solid;background:var(--White,#fff);}", "{", " fieldset{min-height:50px;}}"], function (p) {
    return p.$topMargin ? "".concat(p.$topMargin, "px") : "28px";
  }, function (p) {
    return p.theme.breakpoints.down("sm");
  }, function (p) {
    return (p === null || p === void 0 ? void 0 : p.$mobileTopMargin) && "margin-top: ".concat(p.$mobileTopMargin, "px;");
  }),
  LabelWrapper: styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "FormInput__LabelWrapper",
    componentId: "sc-kr1sqg-3"
  })(["display:flex;align-items:center;"]),
  InputLabel: (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_material_ui_core_InputLabel__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).withConfig({
    displayName: "FormInput__InputLabel",
    componentId: "sc-kr1sqg-4"
  })(["transform:none !important;font-size:18px;color:", ";font-weight:400;", ";line-height:1.44;margin-top:5px;"], function (p) {
    return p.theme.colors.darkGrey;
  }, function (p) {
    return p.$center ? "width: 100%; right: none; text-align: center;" : "";
  }),
  BottomText: (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z).attrs({
    variant: "body1"
  }).withConfig({
    displayName: "FormInput__BottomText",
    componentId: "sc-kr1sqg-5"
  })(["text-align:start;font-size:15px;margin-top:-23px;color:", ";"], function (p) {
    return p.theme.colors.marbleGrey;
  })
};

var FormInput = function FormInput(_ref) {
  var name = _ref.name,
      label = _ref.label,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "text" : _ref$type,
      _ref$required = _ref.required,
      required = _ref$required === void 0 ? false : _ref$required,
      placeholder = _ref.placeholder,
      maxLength = _ref.maxLength,
      numeric = _ref.numeric,
      InputProps = _ref.InputProps,
      centerField = _ref.centerField,
      autoFocus = _ref.autoFocus,
      topMargin = _ref.topMargin,
      mobileTopMargin = _ref.mobileTopMargin,
      props = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_ref, _excluded);

  var _useField = (0,formik__WEBPACK_IMPORTED_MODULE_1__.useField)(name),
      _useField2 = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_useField, 1),
      field = _useField2[0];

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(Styled.FormControl, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(Styled.FieldWrapper, {
      $topMargin: topMargin,
      $mobileTopMargin: mobileTopMargin,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_Bit_Form_FormikInput__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread(_objectSpread({
        name: name,
        type: type,
        required: required,
        placeholder: placeholder,
        maxLength: maxLength,
        numeric: numeric,
        centerField: centerField,
        InputProps: InputProps,
        autoFocus: autoFocus,
        label: label
      }, field), props))
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (FormInput);

/***/ })

}]);